import Button from 'components/Button';
import Icon from 'components/Icon';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import InviteUserModal from 'components/InviteUserModal';

class InviteUser extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {isOpen: false};
    this.handleClick = this.handleClick.bind(this);
    this.handleRequestModalClose = this.handleRequestModalClose.bind(this);
  }

  handleRequestModalClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleClick() {
    this.setState({
      isOpen: true,
    });
  }

  render() {
    return (
      <div>
        <Button
          onClick={this.handleClick}
          type={Button.TYPES.ALT}
          icon={Icon.OPTIONS.PERSON_PLUS}
        >
          <FormattedMessage
            id="InviteUser"
            defaultMessage="Invite to Domo"
            description="Label for invite to Domo button"
          />
        </Button>
        <InviteUserModal
          isOpen={this.state.isOpen}
          onRequestModalClose={this.handleRequestModalClose}
          onOpen={this.props.onOpen}
          onSend={this.props.onSend}
        />
      </div>
    );
  }
}
export default InviteUser;
